import VisitorTracker from "@linsy-utils/page-trace";
import Cookies from "js-cookie";

export default function startTrack(app) {
  // 创建追踪器实例
  const tracker = new VisitorTracker({
    uploadUrl: process.env.VUE_APP_API_TRACKER_URL || '//xstpsit.linshimuye.com/api/nginx/trace',
    batchSize: 1,
    // debug: true,
    trackAnonymous: false,
    disable: process.env.VUE_APP_XSRF_DISABLE === "1",
    plugins: [
      (data) => {
        const matched = app.$route?.matched?.[app.$route?.matched?.length - 1];
        return {
          ...data,
          originSystem: 'MOM', // 系统标识符，每个系统需唯一
          path: matched?.meta?.title || data.url
        }
      }
    ]
  });
  tracker.setUserInfo({
    no: Cookies.get('jobNo')
  });
}
